import { render, staticRenderFns } from "./vue-autocomplete.vue?vue&type=template&id=29db3e09"
import script from "./vue-autocomplete.vue?vue&type=script&lang=js"
export * from "./vue-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports